import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { event } from '@uhg-abyss/web/tools/event';
import Joyride, { EVENTS, ACTIONS } from 'react-joyride';
import { TourGuideTooltip } from './TourGuideTooltip';
// import 'scrolling-element';

export const TourGuide = ({
  isActive,
  steps,
  onClose,
  onUpdate,
  onNext,
  onStart,
  ...props
}) => {
  const [bodyClass, setBodyClass] = useState('');
  const [helpers, setHelpers] = useState({});

  const eventCallback = (eventData) => {
    const { step, type, action } = eventData;

    if (action === ACTIONS.START) {
      if (onStart) {
        onStart();
      }
    }

    if (type === EVENTS.STEP_BEFORE) {
      event('TRAINING_TIP_VIEW', step);
    }

    if (
      type === EVENTS.STEP_BEFORE ||
      action === ACTIONS.STOP ||
      action === ACTIONS.RESET
    ) {
      if (bodyClass) {
        document.body.classList.remove(bodyClass);
        setBodyClass('');
      }
    }

    if (action === ACTIONS.NEXT) {
      if (step.onNext && eventData.lifecycle === 'complete') {
        step.onNext(eventData, helpers);
      }
    }
    if (action === ACTIONS.CLOSE) {
      if (step.onClose && eventData.lifecycle === 'complete') {
        step.onClose(eventData, helpers);
      }
    }

    if (type === EVENTS.STEP_AFTER) {
      if (step.onNext) {
        step.onNext(eventData, helpers);
      }

      if (onUpdate) {
        onUpdate(eventData, helpers);
      }
    }

    if (type === EVENTS.TOUR_END) {
      event('TRAINING_TIP_CLOSE', step);

      if (typeof helpers.reset === 'function') {
        helpers.reset();
      }

      if (bodyClass) {
        document.body.classList.remove(bodyClass);
        setBodyClass('');
      }

      if (onClose) {
        onClose(eventData, helpers);
      }
    }

    if (
      step.bodyClass &&
      action !== ACTIONS.STOP &&
      action !== ACTIONS.RESET &&
      type !== EVENTS.TOUR_END
    ) {
      document.body.classList.add(step.bodyClass);
      setBodyClass(step.bodyClass);
    }
  };

  return (
    <Joyride
      run={isActive}
      tooltipComponent={TourGuideTooltip}
      getHelpers={setHelpers}
      callback={eventCallback}
      steps={steps
        .filter((step) => step.enabled !== false)
        .map((step) => {
          return {
            disableBeacon: true,
            placement: 'auto',
            offset: 10,
            locale: { last: 'Close' },
            ...step,
          };
        })}
      styles={{
        overlay: {
          cursor: 'default',
          mixBlendMode: 'unset',
          backgroundColor: 'transparent',
        },
        spotlight: {
          borderRadius: 0,
          backgroundColor: 'transparent',
          outline: '300vmax rgba(0, 0, 0, 0.5) solid',
          transition: 'unset',
        },
      }}
      {...props}
    />
  );
};

TourGuide.propTypes = {
  isActive: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  onNext: PropTypes.func,
  onStart: PropTypes.func,
  continuous: PropTypes.bool,
  scrollToFirstStep: PropTypes.bool,
  disableBeacon: PropTypes.bool,
};

TourGuide.defaultProps = {
  isActive: false,
  onClose: null,
  onUpdate: null,
  onNext: null,
  onStart: null,
  continuous: true,
  scrollToFirstStep: true,
  disableBeacon: true,
};
